import type { State } from '../../../reducers';

export const getShowGeofenceBottomSheet = (state: State): boolean => state.geofenceBottomSheet.showGeofenceBottomSheet;
